import { module } from 'modujs';
import {AddressForm} from '@shopify/theme-addresses';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                'edit-toggler': 'toggleEdit'
            }
        }
    }

    init() {
        this.id = this.getData('id')
        const form = AddressForm(this.$('form-wrapper-inner')[0], 'en');
    }

    toggleEdit() {
        if (this.el.classList.contains('is-edit')) {
            this.el.classList.remove('is-edit')
        } else {
            this.el.classList.add('is-edit')
        }
    }
}
